export const navItems = [
  {
    id: 3,
    title: "About",
    url: "/about",
  },
];
